import { Card, type CardProps } from 'antd';
import classNames from 'classnames';
import React, { memo } from 'react';

import './styles.less';

interface Props
  extends Pick<
    CardProps,
    | 'id'
    | 'style'
    | 'bodyStyle'
    | 'children'
    | 'className'
    | 'title'
    | 'extra'
    | 'bordered'
    | 'onClick'
    | 'activeTabKey'
    | 'onTabChange'
    | 'tabBarExtraContent'
    | 'tabList'
    | 'tabProps'
  > {
  disabled?: boolean;
}

/**
 * A wrapper around the antd Card with our custom config applied.
 */
function DefaultCard({
  id,
  style,
  bodyStyle,
  children,
  className,
  title,
  extra,
  bordered,
  onClick,
  disabled = false,
  activeTabKey,
  onTabChange,
  tabBarExtraContent,
  tabList,
  tabProps
}: Props): JSX.Element {
  return (
    <Card
      id={id}
      data-testid={id}
      style={style}
      bodyStyle={bodyStyle}
      className={classNames(
        'DefaultCard',
        {
          clickable: !!onClick,
          disabled
        },
        className
      )}
      title={title}
      extra={extra}
      bordered={bordered}
      onClick={disabled ? undefined : onClick}
      activeTabKey={activeTabKey}
      onTabChange={onTabChange}
      tabBarExtraContent={tabBarExtraContent}
      tabList={tabList}
      tabProps={tabProps}
    >
      {children}
    </Card>
  );
}

export default memo(DefaultCard);
